/**
 * Iniziali (max 2) da un nome completo, per il fallback dell'avatar quando il
 * ritratto non c'è: prima lettera del primo e dell'ultimo token, uppercase.
 * "Mario Rossi" -> "MR", "Mario Andrea Rossi" -> "MR", "Mario" -> "M", vuoto -> "?".
 */
export function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
